// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MovementSection_container__wZhVQ {
  text-align: left;
}

.MovementSection_filters__TpQwx {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  padding: 16px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 8px;
}

.MovementSection_filters__select__MrDor {
  width: 21%;
  margin-right: 1%;
}   

.MovementSection_date__oRsfm {
  text-align: left;
  padding: 8px;
  border-radius: 5px;
  margin-right: 1%;
  background: white;
  border: 1px solid rgba(203, 213, 225, 1);
}

.MovementSection_tableWrapper__IuOrJ {
  max-height: 30vw;
  overflow-y: auto; /* важен для «липкой» шапки внутри контейнера */
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

/* убери overflow:hidden у самой таблицы, иначе может клипать */
.MovementSection_table__HaQ-2 {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  /* overflow: hidden;  <-- убираем */
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

/* фиксируем шапку внутри scroll-контейнера */
.MovementSection_table__HaQ-2 thead th {
  position: sticky;
  top: 0; /* расстояние от верхней границы контейнера .tableWrapper */
  z-index: 5;
  background-color: #f9f9f9;
}



.MovementSection_page__gpPfV {
  color: red;
}
.MovementSection_table__HaQ-2 th,
.MovementSection_table__HaQ-2 td {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
  font-size: 14px;
}

.MovementSection_table__HaQ-2 th {
  background-color: #f9f9f9;
  font-weight: 600;
  color: #333;
}

.MovementSection_table__HaQ-2 tr:hover {
  background-color: #f5f5f5;
}


.MovementSection_menuBtn__eEA\\+X {
  background: transparent;
  border: none;
  cursor: pointer;
}

.MovementSection_menu__iEqJ1 {
  position: absolute;
  width: 140px;
  background: white;
  right: -30px;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  display: flex;
  flex-direction: column;
  z-index: 10;
}

.MovementSection_menu__iEqJ1 button {
  padding: 8px 12px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
}

.MovementSection_menu__iEqJ1 button:hover {
  background: #f5f5f5;
}

.MovementSection_addCustomers__w7K73 {
  margin-bottom: 20px;
  background: rgba(29, 135, 82, 1);
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/tablesStyle/MovementSection.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB,EAAE,+CAA+C;EACjE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,MAAM,EAAE,2DAA2D;EACnE,UAAU;EACV,yBAAyB;AAC3B;;;;AAIA;EACE,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".container {\n  text-align: left;\n}\n\n.filters {\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  padding: 16px;\n  background-color: rgba(255, 255, 255, 1);\n  border-radius: 8px;\n}\n\n.filters__select {\n  width: 21%;\n  margin-right: 1%;\n}   \n\n.date {\n  text-align: left;\n  padding: 8px;\n  border-radius: 5px;\n  margin-right: 1%;\n  background: white;\n  border: 1px solid rgba(203, 213, 225, 1);\n}\n\n.tableWrapper {\n  max-height: 30vw;\n  overflow-y: auto; /* важен для «липкой» шапки внутри контейнера */\n  overflow-x: auto;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n}\n\n/* убери overflow:hidden у самой таблицы, иначе может клипать */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  /* overflow: hidden;  <-- убираем */\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n\n/* фиксируем шапку внутри scroll-контейнера */\n.table thead th {\n  position: sticky;\n  top: 0; /* расстояние от верхней границы контейнера .tableWrapper */\n  z-index: 5;\n  background-color: #f9f9f9;\n}\n\n\n\n.page {\n  color: red;\n}\n.table th,\n.table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  text-align: left;\n  font-size: 14px;\n}\n\n.table th {\n  background-color: #f9f9f9;\n  font-weight: 600;\n  color: #333;\n}\n\n.table tr:hover {\n  background-color: #f5f5f5;\n}\n\n\n.menuBtn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n.menu {\n  position: absolute;\n  width: 140px;\n  background: white;\n  right: -30px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n  display: flex;\n  flex-direction: column;\n  z-index: 10;\n}\n\n.menu button {\n  padding: 8px 12px;\n  border: none;\n  background: none;\n  text-align: left;\n  cursor: pointer;\n}\n\n.menu button:hover {\n  background: #f5f5f5;\n}\n\n.addCustomers {\n  margin-bottom: 20px;\n  background: rgba(29, 135, 82, 1);\n  color: white;\n  padding: 10px 20px;\n  border-radius: 5px;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MovementSection_container__wZhVQ`,
	"filters": `MovementSection_filters__TpQwx`,
	"filters__select": `MovementSection_filters__select__MrDor`,
	"date": `MovementSection_date__oRsfm`,
	"tableWrapper": `MovementSection_tableWrapper__IuOrJ`,
	"table": `MovementSection_table__HaQ-2`,
	"page": `MovementSection_page__gpPfV`,
	"menuBtn": `MovementSection_menuBtn__eEA+X`,
	"menu": `MovementSection_menu__iEqJ1`,
	"addCustomers": `MovementSection_addCustomers__w7K73`
};
export default ___CSS_LOADER_EXPORT___;
